/*
 *  Footer
 *    Scripts for the footer
 *
 *  Version:
 *    1.0.0 - 2022/02/05
 */

import {
  initAccordion,
  closeAccordion,
  openAccordion,
} from '../objects/accordion/accordion';
import { MEDIUM } from '../settings/responsive';

// Selectors
const SELECTOR_CONTAINER = '[data-footer]';
const SELECTOR_ACCORDION = '[data-accordion-container]';

const footer = document.querySelector<HTMLElement>(SELECTOR_CONTAINER);

const isTracktor = document
  .querySelector('#tracktor')
  ?.classList.contains('themeLight');
const headerContainer = document.querySelector<HTMLElement>('.c-header');

if (isTracktor) headerContainer?.classList.add('is-inverted');

setTimeout(function () {
  const sourceSelect = document.querySelector(
    '.c-page--product .locale-selectors__container'
  );
  sourceSelect?.classList.add('fix-padding');
}, 4000);

if (footer) {
  const accordionContainer =
    footer.querySelector<HTMLElement>(SELECTOR_ACCORDION);

  if (accordionContainer) {
    // We always initialise the accordion
    // - the event handler will check sizes before firing
    initAccordion({ container: accordionContainer, disableSize: 'MEDIUM' });

    // But we'll open or close the accordions based on the size
    if (window.innerWidth < MEDIUM) {
      closeAccordion(accordionContainer);
    } else {
      openAccordion(accordionContainer);
    }

    // Open/close accordion based on window size
    window.addEventListener('resize', () => {
      if (window.innerWidth < MEDIUM) {
        closeAccordion(accordionContainer);
      } else {
        openAccordion(accordionContainer);
      }
    });
  }
}
